import { Spinner } from '@teliaee/design-system';
import { observer } from 'mobx-react';
import * as React from 'react';
import UiNotice from '../components/UiNotice';
import useStores from '../stores/UseStores';

const LogoutPage = observer((): React.JSX.Element => {
  const {
    logoutStore,
    uiStore: { hasNotice },
  } = useStores();

  React.useEffect(() => {
    logoutStore.logOut();
  }, []);

  if (hasNotice) {
    return <UiNotice />;
  }
  return <Spinner />;
});

export default LogoutPage;
